var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUppercase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uppercase"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M22.4389 8.95115C22.4389 8.95115 21.3309 6 18.1079 6C15.1151 6 13 8.57802 13 12.2415C13 15.922 15.1151 18.5 18.1079 18.5C20.8561 18.4322 22.9856 16.5156 22.9856 13.0047C22.9856 13.0047 23 12.445 23 12.021H18.295M9.37616 13.4792L6.92458 6.65403C6.78313 6.26024 6.42703 6 6.02964 6C5.63395 6 5.279 6.25806 5.13637 6.64945L2.64746 13.4792M9.37616 13.4792L11 18M9.37616 13.4792H2.64746M1 18L2.64746 13.4792",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUppercase);
export default __webpack_public_path__ + "static/media/uppercase.d5d50e15c2bb4c91414eace6edf3ce16.svg";
export { ForwardRef as ReactComponent };